import { AttachmentEntityInterface } from '@types';
import { AttachmentFormats, ImageShape } from '@enums';

export const createPersonImageAttach = (
  id: string,
  data: string | { [keyShape in ImageShape]: string }
): AttachmentEntityInterface => {
  const name = `${id}.png`;
  return {
    data: {
      name,
      contentID: name,
      data: Object.fromEntries(
        Object.entries(data).map(([key, value]) => [key, value.slice(22)])
      ) as typeof data,
      contentType: 'image/png',
      inline: true,
    },
    format: AttachmentFormats.PNG,
    name,
  };
};
